import ConfirmDialog from './confirm-dialog';

export default ConfirmDialog;